import React, { useContext, useMemo } from 'react';
import styled from 'styled-components/macro';
import { isEmpty } from 'lodash';
import scaleSize from 'utils/scale-size';
import ArrowIcon from 'components/Icons/back';
import { EPGContext } from './EPGContext';
import Categories from './Categories';
import TimeBar from './TimeBar';
import ChannelsList from './ChannelsList';
import NoContentStub from './NoContentStub';

const StyledArchivePointer = styled.div`
  display: block;
  position: absolute;
  width: ${scaleSize(142)}px;
  height: ${scaleSize(48)}px;
  left: -${scaleSize(20)}px;
  top: ${scaleSize(593)}px;
  font-family: RobotoRegular, sans-sefir;
  font-style: normal;
  font-weight: 900;
  text-transform: uppercase;
  text-align: center;
  font-size: ${scaleSize(22)}px;
  line-height: ${scaleSize(48)}px;
  letter-spacing: 2px;
  color: #ffffff;
  transform: rotate(-90deg);

  svg {
    height: ${scaleSize(28)}px;
    width: ${scaleSize(22)}px;
    display: block;
    margin: 0 auto;
    transform: rotate(90deg);
  }
`;

const MainView = (props) => {
  const { categories, channels, currentCategoryId, playingChannelId, focusedChannelId } = props;
  const { onChannelEnter, onChannelFocus, onCategoryEnter } = props;
  const { sheetStartTimeMs, sheetEndTimeMs, currentTimeMs } = useContext(EPGContext);

  const isHasNoContent = isEmpty(channels);

  const isFocusedChannelHasEpg = useMemo(() => {
    const focusedChannel = channels.find((ch) => ch.id === focusedChannelId);

    return !isEmpty(focusedChannel?.epg);
  }, [channels, focusedChannelId]);

  const defaultIndex = useMemo(() => {
    const id = focusedChannelId ? focusedChannelId : playingChannelId;
    return channels.findIndex((ch) => ch.id === id);
  }, [playingChannelId, channels, focusedChannelId]);

  const categoriesConfig = useMemo(
    () => ({
      leaveFor: {
        up: '@EPG-BACK-BUTTON',
        left: '@EPG-BACK-BUTTON',
        right: '',
        down: isHasNoContent ? '' : undefined,
      },
    }),
    [isHasNoContent],
  );

  const contentMarup = (
    <>
      <TimeBar startTime={sheetStartTimeMs} currentTime={currentTimeMs} endTime={sheetEndTimeMs} />
      <ChannelsList
        channels={channels}
        onEnter={onChannelEnter}
        onFocus={onChannelFocus}
        defaultIndex={defaultIndex}
      />
    </>
  );

  return (
    <>
      {isFocusedChannelHasEpg && (
        <StyledArchivePointer>
          <ArrowIcon />
          Archive
        </StyledArchivePointer>
      )}
      <Categories
        categories={categories}
        currentCategoryId={currentCategoryId}
        config={categoriesConfig}
        onEnter={onCategoryEnter}
      />
      {isHasNoContent ? <NoContentStub /> : contentMarup}
    </>
  );
};

export default MainView;
